import React, { useState, useEffect } from 'react'
import { useRouter } from '../../hooks/router'

import Category from './Category'
import './Channels.scss'
import { decrypt } from '../../components/Util/util'

import { remove_channel_from_favourites, add_channel_to_favourites } from '../../server/requests'

export default ({
    categories,
    activeChannelId,
    favourites,
    setResultSearch
}) => {
    const router = useRouter()

    const [listCategory, setListCategory] = useState([]);
    const [valueSearch, setValueSearch] = useState('');
    const [changeFav, setChangeFav] = useState(false)

    useEffect(() => {
        setListCategory([...categories])
    }, [categories]);

    useEffect(() => {

    }, [changeFav])

    const btnCategory = (i) => {
        let newArray = [...categories]

        newArray[i].selected = !newArray[i].selected
        setListCategory([...newArray])
    }

    const searchHandler = (e) => {
        setValueSearch(e.target.value)
        if (router.query.type) {
            router.push(`?type=${router.query.type}&id=${router.query.id}&search=${e.target.value}`)
        } else {
            router.push(`?id=${router.query.id}&search=${e.target.value}`)
        }
    }


    const btn_add_remove_favourites = (channel) => {

        const user = JSON.parse(decrypt('user', localStorage.getItem('user')))

        let body = {
            subId: user.type == 'root_account' ? '0' : user.id,
            channel_id: channel.id
        }

        if (channel.is_favourite) {
            remove_channel_from_favourites(body, data => {

                let _categories = JSON.parse(JSON.stringify(categories))
                for (let i = 0; i < _categories.length; i++) {
                    let fav_channel
                    if (_categories[i].channels) {
                        fav_channel = _categories[i].channels.find(e => e.id == channel.id)
                        if (fav_channel) fav_channel.is_favourite = false
                        if (i == 1) {
                            _categories[i].channels.splice(_categories[i].channels.indexOf(fav_channel), 1)
                        }

                    }

                }
                setResultSearch([..._categories])
            }, err => console.log(err))
        } else {

            add_channel_to_favourites(body, data => {

                let _categories = JSON.parse(JSON.stringify(categories))

                if (_categories[1].channels) _categories[1].channels.push(channel)
                else _categories[1].channels = [channel]

                for (let i = 0; i < _categories.length; i++) {

                    let fav_channel

                    if (_categories[i].channels) {

                        fav_channel = _categories[i].channels.find(e => e.id == channel.id)
                        if (fav_channel) fav_channel.is_favourite = true

                    }

                }

                setResultSearch([..._categories])

            }, err => console.log(err))
        }




    }

    return (
        <>
            <div className="parent_search_channels">
                <input type="text" value={valueSearch} placeholder={'Search'} onKeyDown={e => e.stopPropagation()} onChange={e => searchHandler(e)} />
            </div>
            <div className={"main_channel_list_live "}>
                {listCategory.map((e, i) => {

                    return (
                        <Category
                            key={e.id}
                            category={e}
                            index={i}
                            activeChannelId={activeChannelId}
                            btnCategory={btnCategory}
                            btn_favourites={btn_add_remove_favourites}
                        />
                    )
                })}
            </div>
        </>
    )

}